import { createContext } from "react";
import { GroupStore } from "@gp/offer";

export const GroupStoreContext = createContext<GroupStore>({} as any);